export default __webpack_public_path__ + "static/media/no_agreement.03123ede.png";